import { Fragment, ReactElement } from 'react';
import ResearchMarriageNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-marriage';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchMarriageNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchMarriageNotificationsCivilStatusShared scope={IdAmbito.Cancellazioni} />
    </Fragment>
  );
};

ResearchMarriageNotificationsCivilStatusPage.displayName =
  'Research Marriage Notifications CivilStatusPage component';

export default ResearchMarriageNotificationsCivilStatusPage;
